import { render, staticRenderFns } from "./HazardTable.vue?vue&type=template&id=91200880"
import script from "./HazardTable.vue?vue&type=script&lang=js"
export * from "./HazardTable.vue?vue&type=script&lang=js"
import style0 from "./HazardTable.vue?vue&type=style&index=0&id=91200880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports